/* 馬超傳・第 1 章：平陽・斬郭援（建安七年，202）
 * 史實：〈馬超傳〉「騰遣超隨繇討郭援、高幹於平陽，超將龐德親斬援首。」
 *       裴注引《典略》「超為司隸校尉督軍從事，討郭援，為飛矢所中，乃以囊囊其足而戰，破斬援首。」
 *       〈鍾繇傳〉「且援剛愎好勝，必易吾軍，若渡汾爲營，及其未濟擊之，可大克也。」「援至，果輕渡汾，衆止之，不從。濟水未半，擊，大破之」。
 *       （〈鍾繇傳〉沒寫年份；章名的建安七年是通行的繫年。）
 * 流程：隨鍾繇推進到汾水西岸 → 郭援輕渡汾水，等他渡到一半出擊（半渡而擊）→ 馬超中流矢，站定以囊裹足再戰 →
 *       郭援傷重，讓龐德上前斬首（斬首的是龐德，馬超搶到最後一擊不算如史）→ 袁軍大潰。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, rout } from '../kit.ts';
import { MEN, YUAN, band } from './machao_kit.ts';
import { FORD, CAMP, YUAN as YCAMP } from '../maps/machao_pingyang.ts';

const LV = 6, BANK = [3000, 2200];
const YB = { spec: YUAN, name: '袁軍', hp: 400, maxHp: 400, atk: 24 };
const inRiver = (u) => SG.MAP.waterAt(u.x, u.y) && Math.abs(u.x - FORD[0]) < 400;

export default {
  id: 'machao-1', map: 'machao_pingyang', hero: 'machao',
  title: '第 1 章　平陽・斬郭援', year: '建安七年（202）',
  brief: {
    quote: [{ text: '騰遣超隨繇討郭援、高幹於平陽，超將龐德親斬援首。', src: '《三國志·蜀書·馬超傳》' }],
    text: '匈奴單于在平陽作亂，鍾繇率軍圍城。袁尚所置的河東太守郭援帶大軍來救，諸將想退，鍾繇不肯。張既說動馬騰，馬騰派兒子馬超帶兵會擊郭援，龐德隨行。兩軍隔著汾水。',
    goals: ['隨鍾繇推進到汾水西岸', '等郭援渡河渡到一半再出擊', '中箭後站定，以囊裹足再戰', '讓龐德斬郭援'],
  },
  words: { ally: '西涼騎', foe: '袁軍' },
  stars: [
    { text: '半渡而擊：郭援還在河中時出擊', ok: (m) => !!m.vars.half },
    { text: '囊足之後部下零陣亡', ok: (m) => m.vars.lost0 != null && m.stats.lost === m.vars.lost0 },
    { text: '如史：龐德親斬援首', ok: (m) => !!m.vars.pdKill },
  ],
  steps: [
    { // 0. 推進到汾水西岸
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] + 300; me.y = CAMP[1];
        V.pd = ally(w, 'pangde', me.x - 60, me.y + 90, LV);
        V.zy = ally(w, 'zhongyao', me.x - 200, me.y - 60, LV);
        V.men = band(m, me, 6);
        // 東岸：郭援、高幹的袁軍
        V.gy = boss(w, MEN.guoyuan, YCAMP[0] - 300, YCAMP[1], { name: '郭援', hp: 2800, atk: 48, armor: 5, ms: 220, gold: 300, xp: 400 });
        V.gg = boss(w, MEN.gaogan, YCAMP[0] + 100, YCAMP[1] - 150, { name: '高幹', hp: 2400, atk: 42, armor: 5, ms: 220 });
        V.foes = Array.from({ length: 14 }, (_, i) => m.foe('huangjin', YCAMP[0] - 500 + (i % 4) * 90, YCAMP[1] - 200 + Math.floor(i / 4) * 140, YB));
        m.line('鍾繇', '郭援就在汾水東岸。先到西岸列陣，看他怎麼過河。');
        m.mark('bank', BANK[0], BANK[1], '汾水西岸');
        m.obj('bank', '隨鍾繇推進到汾水西岸');
      },
      tick(m, w) { return m.near(w.player, BANK[0], BANK[1], 320); },
    },
    { // 1. 郭援輕渡汾水：半渡而擊
      enter(m, w) {
        const V = m.vars;
        m.done('bank'); m.unmark('bank');
        m.line('鍾繇', '援剛愎好勝，必易吾軍。若渡汾為營，及其未濟擊之，可大克也。');
        m.after(4, () => {
          m.card('援至，果輕渡汾，衆止之，不從。', '《三國志·魏書·鍾繇傳》');
          // 袁軍排成縱隊涉水過來
          V.cross = true;
          [V.gy].concat(V.foes).forEach((u, i) => m.after(i * 0.7, () => { if (u.alive) u.home = [BANK[0] - 200, BANK[1] + ((i % 3) - 1) * 120]; }));
        });
        m.after(6, () => m.line('提示', '等郭援的兵有一半下了水再衝過去：在河裡的人走得慢。太早或太晚都打不出「半渡而擊」。'));
        m.obj('half', '等郭援渡到一半，出擊');
      },
      tick(m, w) {
        const V = m.vars, list = [V.gy].concat(V.foes);
        if (!V.cross) { for (const u of list) if (u.alive) u.target = null; return false; }
        const wet = list.filter((u) => u.alive && inRiver(u)).length, over = list.filter((u) => u.alive && u.x < FORD[0] - 280).length;
        // 我方先動手：看當下有多少人還在河中
        const hit = list.some((u) => u.hp < u.maxHp || !u.alive);
        if (hit || over >= list.length * 0.8) {
          V.half = hit && wet >= 3 && over < list.length / 2;
          if (V.half) m.big('半渡而擊！');
          return true;
        }
        return false;
      },
    },
    { // 2. 大戰：中流矢、囊足
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('half');
        V.t2 = w.t;
        for (const u of [V.gy].concat(V.foes)) if (u.alive) u.home = [me.x, me.y];
        V.gg.home = [FORD[0] + 600, FORD[1]];
        m.obj('gy', '擊破郭援');
        m.mark('gy', V.gy.x, V.gy.y, '郭援', false, V.gy);
        m.after(7, () => {
          if (!me.alive) return;
          m.hurt(me, me.maxHp * 0.12, 1, { stagger: 0.4 });
          w.addBuff(me, { id: '中箭', t: 9999, ms: -0.6, neg: true });
          V.shot = true;
          m.big('馬超中了流矢！');
          m.line('馬超', '……腳中了一箭。拿囊來裹上！');
          m.obj('wrap', '站定不動，以囊裹足');
        });
      },
      tick(m, w) {
        const me = w.player, V = m.vars, gy = V.gy;
        // 囊足：站定 2.5 秒（移動就斷）
        if (V.shot && !V.wrapped && !me.chan && m.idle(me)) m.chan(me, 2.5, '以囊囊足', () => {
          V.wrapped = true; V.lost0 = m.stats.lost;
          w.addBuff(me, { id: '中箭', t: 0.01 }); // 拿掉中箭的減速
          w.addBuff(me, { id: '囊足', t: 9999, ms: -0.12, neg: true });
          m.done('wrap');
          m.card('為飛矢所中，乃以囊囊其足而戰。', '《典略》（裴注）');
        }, { hurt: false });
        // 郭援傷重：龐德上前斬首
        if (gy.alive && !V.pdGo && gy.hp < gy.maxHp * 0.3) { V.pdGo = true; m.line('龐德', '將軍且退，這顆首級交給龐德！'); }
        if (gy.alive && V.pdGo && V.pd.alive && SG.gd(V.pd.x, V.pd.y, gy.x, gy.y) < 170) {
          V.pdKill = true;
          w.fx({ k: 'slam', x: gy.x, y: gy.y, r: 160, col: '#eef0f6' });
          m.hurt(gy, 99999, 0);
        }
        return !gy.alive;
      },
    },
    { // 3. 袁軍大潰
      enter(m, w) {
        const V = m.vars;
        m.done('gy'); m.unmark('gy');
        m.card(V.pdKill ? '超將龐德親斬援首。' : '破斬援首。', V.pdKill ? '〈馬超傳〉' : '《典略》（裴注）');
        m.after(3, () => m.card('濟水未半，擊，大破之。', '〈鍾繇傳〉'));
        rout(m, w, m.alive(V.foes).concat([V.gg]), [YCAMP[0] + 600, YCAMP[1]]);
        m.after(7, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('馬超陣亡'); return; }
    if (V.zy) allyTick(w, V.zy, me, 400);
    if (V.pd) {
      if (V.pdGo && V.gy.alive) { const I = V.pd.input; I.target = V.gy; I.engage = true; I.moveTo = null; }
      else allyTick(w, V.pd, me, 450);
    }
    if (m.i === 2 && V.gy && V.gy.alive && !(V.gy.target && V.gy.target.alive)) V.gy.home = [me.x, me.y];
    // 郭援、高幹認得馬超：馬超靠近就衝著他來
    for (const b of [V.gy, V.gg]) if (b && b.alive && !b.rout && SG.gd(b.x, b.y, me.x, me.y) < 450 && (m.i >= 2 || !V.cross || SG.gd(b.x, b.y, me.x, me.y) < 300) && b.target !== me) { b.target = me; b.think = 0.5; }
  },
};
